import { render, staticRenderFns } from "./VaultRenameCategoryModal.vue?vue&type=template&id=1de84c15&"
import script from "./VaultRenameCategoryModal.vue?vue&type=script&lang=ts&"
export * from "./VaultRenameCategoryModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports